import React from 'react';
import { ReactSVG } from 'react-svg';
import { FaPlus } from 'react-icons/all';
import { TmoButtons as TmoButton } from '@tmobile/tmo-bps-syncup-web-component-lib';
import Feature from '../featureWrappers/Feature';
import AddThing from './AddThing';
import { APP_MOBILE } from '../../utils/app_constants';
import { generateThingsFieldSpecs } from '../../utils/addThingsFieldsSpecHelper';
import style from './Things.module.css';
import refreshIcon from '../../static/assets/icons/refresh.svg';

/**
 * ThingActions
 *
 * Renders action buttons related to a Thing entity:
 *  - Manual refresh (if a Thing already exists)
 *  - Add new Thing (feature-gated by product)
 *
 * This component does not manage state itself;
 * it relies entirely on callbacks passed via props.
 */

const ThingActions = ({
  thing, // Existing thing instance (if present)
  thingTypeName, // Display name of the thing type (e.g., Device, Pet)
  handleManualRefresh, // Callback to manually refresh thing data
  openAddThingModal, // Callback to open "Add Thing" modal
  productType // Product type used to configure AddThing form
}) => {
  return (
    <div className={style.thing_actions}>
      {thing && (
        <TmoButton
          onClick={handleManualRefresh}
          type="magenta_secondary"
          tooltip="Refresh"
          icon={<ReactSVG src={refreshIcon} />}
        />
      )}

      <Feature
        isUserDetails
        Products={[
          APP_MOBILE.PETS,
          APP_MOBILE.TRACKER,
          APP_MOBILE.WATCH,
          APP_MOBILE.FAMILYLOCATION
        ]}
      >
        <TmoButton
          className={style.add_thing}
          onClick={openAddThingModal}
          icon={<FaPlus />}
          type="magenta_primary"
        >
          Add New {thingTypeName}
        </TmoButton>

        <AddThing
          thingType={productType}
          fieldSpecs={generateThingsFieldSpecs({
            syncUpAppName: productType
          })}
        />
      </Feature>
    </div>
  );
};

export default ThingActions;
